import { FormGroup } from '@angular/forms';

export default function updateFormGroupFromJson(formGroup: FormGroup, json: object) {
  Object.entries(json)
    .filter(([key]) => formGroup.controls.hasOwnProperty(key))
    .forEach(([key, value]) => {
      formGroup.controls[key].setValue(value);
    });
}
